import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay';

const mutation = graphql`
    mutation setNonTradeUserToSuspectedTradeMutation(
        $input: SetNonTradeUserToSuspectedTradeInput!
    ) {
        setNonTradeUserToSuspectedTradeMutation(input: $input) {
            verifiedTradeStatus
        }
    }
`;

export function setNonTradeUserToSuspectedTradeMutation(environment, args) {
    const { userId, onSuccess = () => {}, onFailure = () => {} } = args;

    const input = {
        userId,
    };

    return commitMutation(environment, {
        mutation,
        variables: { input },
        onCompleted: (payload, errors) => {
            if (errors) {
                onFailure(errors);
                return;
            }
            onSuccess(payload);
        },
        onError: error => {
            onFailure([error]);
        },
    });
}
